export const ROUTE_PREFIXES = {
  REPORTS: 'reports',
} as const;

export const ROUTES = {
  NOT_FOUND: '/404',
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  USERPROFILE: '/user-profile',
  FORGOTPASSWORD: '/forgot-password',
  PROJECTS: '/projects',
  PROJECT_VERSIONS: '/project-versions',
  PAYAPPS: '/payapp',
  PROCESSPAYAPP: '/process-payapp',
  CA_INVOICE: '/cost-analysis-invoice',
  CC_INVOICE: '/construction-cost-invoice',
  UPLOADTODB: '/uploadDivision',
  CA_REPORTS: `/${ROUTE_PREFIXES.REPORTS}/cost-analysis-reports`,
  GENERATE_REPORT: '/generate-report',
  LINEITEMS: '/lineitems',
  PROJECT_ANALYSIS: '/project-analysis',
  COMPS: '/comparables',
  CC_REPORTS: `/${ROUTE_PREFIXES.REPORTS}/construction-cost-reports`,
  QCC_REPORTS: `/${ROUTE_PREFIXES.REPORTS}/quarterly-construction-cost-reports`,
  LIMITED_REPORT: '/limited-report',
  MAGIC_REPORT: '/magic-report',
  USERS: '/users',
  USER_PROFILE: '/user-profile',
} as const;

export const API = {
  PROJECT: 'project/',
  PROJECTS: 'projects/',
  PROJECT_VERSION: 'project-versions/',
  UPLOAD_FILE: 'upload/',
  UPLOAD_PAYAPP: 'project/upload-payapp',
  PAYAPPS: '/payapps',
  DIVISIONS: '/divisions',
  LINE_ITEMS: '/line-items',
  UPLOAD_DIVISION: 'upload/upload-divisions',
  CA_REPORT: '/cost-analysis-reports',
  CA_REPORT_LINE_ITEM: '/cost-analysis-report-line-items',
  PROJECT_ANALYSIS: '/project-analyses',
  PROJECT_ANALYSIS_LINE_ITEM: '/project-analysis-line-items',
  COMP_PROJECT_ANALYSIS: '/comp-project-analyses',
  DELETE_PROJECT: 'project/delete',
  LOGIN: 'user/login',
  LOGOUT: 'user/logout',
  HISTORY: 'history',
  CONSTRUCTION_COST_REPORTS: '/construction-cost-reports',
  QUARTERLY_CC_REPORTS: '/quarterly-construction-cost-reports',
  LIMITED_REPORTS: '/limited-reports',
  MAGIC_REPORTS: '/magic-reports',
  INVOICES: '/invoices',
  ADDRESS: '/address',
  OPEN_AI: '/open-ai',
  USER: '/user',
} as const;
